import script from "./Playoffs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Playoffs.vue?vue&type=script&setup=true&lang=ts"

import "./Playoffs.vue?vue&type=style&index=0&id=5497872c&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5497872c"]])

export default __exports__